export default "__VITE_ASSET__BqIT73o3__"